
import { Toast,Dialog } from "vant";
import { useRouter } from 'vue-router'
import {BTN_HANDEL} from '@/hooks/index'
import { inject ,reactive} from 'vue'
import { getCart } from "@/hooks/index";
export default {
     components: {
      [Dialog.Component.name]: Dialog.Component,
  },
    props:{
        good_objs:{  //商品信息
            type:Object,
            required: true,
            default:()=>{
                return {}
            }
        },
        beforeClose:{
            type:Function,          
        },
        index:{
          type:Number
        },
        cart_list:{
          type:Array,
          default:()=>{
                return []
            }
        }
    },
  setup(props:any,{emit}:any){
    const $http: any = inject("$http");
      const router = useRouter()
      //获取货币
    const $store: any = inject('$store')
    const currencyUnit:String = $store.getSymbol();
  
    
      //页面跳转
      const goodsDetails = (goods_id:string):void=>{
          router.push({
              name:'goods',
              params:{
                  id:goods_id
              }
          })
      }
       //删除返回状态
      const deleteClick = (goods_id:string,index:number):void=>{
          Dialog.confirm({
            title: 'Tips?',
            message: 'Are you sure to delete it?',
            confirmButtonText:'Delete',
            cancelButtonText:'Cancel'
            })
            .then(() => {
                // on confirm
                emit('beforeClose',{type:BTN_HANDEL.DELETE,goods_id:goods_id,index})                                 
            })
            .catch(() => {
              //取消
            });
      }         
      //加入购物车
      const addGoodsCart = async (goods_id:string) =>{
        let ret = await $http.cart_create({
          quantity: 1,
          goods_id: goods_id,
        });
        if (ret.code === 200) {
          Toast("success");
          let existed = false;
           props.cart_list.forEach((j: any) => {
            if (j.goods_id != goods_id) return;
            existed = true;
          });
          if (!existed) {
            let newCart: any = props.cart_list.concat(ret.data);
            console.log(newCart,'newCart')
            $store.setCart(newCart);
          } 
        } else {
          Toast(ret.message);
        }
      }
      return {
          goodsDetails,
          currencyUnit,
          deleteClick,
          addGoodsCart
      }
  }
}
